// import 'swiper/swiper-bundle.css';
import Vue from "vue";
import Swiper from "swiper/swiper-bundle";

Vue.prototype.$swiper = Swiper;
